<template>
  <article-locale-layout :article-locale="articleLocale">
    <app-article class="article--blog" :article="article">
      <template #cover>
        <article-cover v-if="article.title" :article="article" />
        <p v-if="article.description" class="article__desc">{{ article.description }}</p>
      </template>
      <template #footer>
        <!-- <article-footer :tags="article.tags" /> -->
      </template>
    </app-article>
  </article-locale-layout>
</template>

<script>
import Article from '../article'
import ArticleCover from '../articleCover'
// import ArticleFooter from '../articleFooter'
import ArticleLocaleLayout from '../articleLocaleLayout'

export default {
  components: {
    'app-article': Article,
    'article-cover': ArticleCover,
    // 'article-footer': ArticleFooter,
    'article-locale-layout': ArticleLocaleLayout,
  },
  props: {
    /**
     * Article data
     */
    article: {
      required: true,
      type: Object,
    },

    /**
     * Article locale code
     */
    articleLocale: {
      required: true,
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
/* Article base styles */
.article::v-deep {
  @apply mb-12;

  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    @apply mt-9 -mb-4;
  }
  & p,
  & .article-cta {
    @apply mt-9;
  }
  & ul,
  & ol {
    @apply mt-5;
  }
  & li > p,
  & li > ul,
  & li > ol {
    @apply mt-0;
  }

  & figure,
  & .article-iframe {
    @apply mt-9 mb-12;
  }
  & hr {
    @apply my-12;
  }

  & .article-cover,
  & .article__desc,
  & .article-ftr {
    @apply mt-12;
  }
}

@screen mobile {
  .article::v-deep {
    &,
    & .article-row__container {
      @apply max-w-article-mobile px-4;
    }
    &,
    & p,
    & li,
    & h4,
    & h5,
    & h6 {
      font-size: 18px;
    }
  }
  .article-cover::v-deep {
    & .article-cover-img {
      @apply w-screen;
      margin-left: calc(50% - 50vw);
    }
  }
}

@screen desktop {
  .article::v-deep {
    &,
    & .article-row__container {
      @apply max-w-article-desktop;
    }
    &,
    & p,
    & li,
    & h4,
    & h5,
    & h6 {
      font-size: 20px;
    }
  }
  .article-cover.article-cover--wide::v-deep {
    width: 960px;
    margin-left: -127px; /* (704px - 960px) / 2 */

    & h1,
    & .article-byline {
      @apply px-4;
    }
  }
}
</style>
